import { allowedVideosFormats, allowedImagesFormats } from '../marketplace-custom-config';

export const ConditionalWrapper = ({ condition, wrapper, children }) =>
    condition ? wrapper(children) : children;

export const isVideo = format => allowedVideosFormats.includes(format);
export const isImage = format => allowedImagesFormats.includes(format);
